import { useState, useEffect, useCallback } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "services/firebaseConfig";
import { isParkOpen } from "utils/calendarRules";

export const useCalendarRules = () => {
  const [excecoes, setExcecoes] = useState([]);
  const [mesesFechamento, setMesesFechamento] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Escuta em tempo real o documento de configuração do calendário
    const docRef = doc(db, "config", "calendario");

    const unsubscribe = onSnapshot(
      docRef,
      (docSnap) => {
        if (docSnap.exists()) {
          const data = docSnap.data();
          setExcecoes(data.excecoes || []);
          setMesesFechamento(data.mesesFechamento || []);
        } else {
          // Valores padrão se o documento não existir
          setExcecoes([]);
          setMesesFechamento([]);
        }
        setIsLoading(false);
      },
      (error) => {
        console.error("Erro ao buscar regras do calendário:", error);
        setIsLoading(false);
      },
    );

    return () => unsubscribe();
  }, []);

  const checkDateAvailability = useCallback(
    (dateObj) => {
      // Se ainda estiver carregando, por segurança, consideramos "aberto" ou esperamos.
      // Aqui vamos deixar passar e a UI controla o loading.
      if (isLoading) return true;

      return isParkOpen(dateObj, excecoes, mesesFechamento);
    },
    [isLoading, excecoes, mesesFechamento],
  );

  return {
    excecoes,
    mesesFechamento,
    checkDateAvailability,
    isLoading,
  };
};
